import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog, DialogTitle, DialogContent,
} from '@material-ui/core';
import { object, string } from 'yup';
import { FormattedMessage } from 'react-intl';
import MyForm from '../../form/MyForm';
import { MY_FORM_FIELD_IMAGE } from '../../form/form-constants';
import { seedAppIcons } from '../../icon/seed-icons';

const namePhotoURL = 'photoURL';

const fields = [
  {
    name: namePhotoURL,
    type: MY_FORM_FIELD_IMAGE,
    labelId: 'seed.firebase.authentication.form.photoURL',
    inputProps: {
      autoFocus: true,
    },
  },
];

const validationSchema = object({
  [namePhotoURL]: string()
    .nullable()
    .required('seed.firebase.authentication.form.photoURL.required'),
});


const SeedFirebaseUpdatePhotoDialog = (props) => {
  const {
    open,
    onClose,
    isLoading,
    onSubmit,
    photoURL,
    icons,
  } = props;

  const initialValues = {
    [namePhotoURL]: photoURL,
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <FormattedMessage id="seed.firebase.authentication.updatePhoto.dialog.title" />
      </DialogTitle>
      <DialogContent>
        <MyForm
          fields={fields}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          disabled={isLoading}
          initialValues={initialValues}
          submitButtonLabelId="seed.firebase.authentication.updatePhoto.button.update"
          icons={icons}
        />
      </DialogContent>
    </Dialog>
  );
};

SeedFirebaseUpdatePhotoDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  photoURL: PropTypes.string,
  icons: PropTypes.objectOf(PropTypes.object),
};

SeedFirebaseUpdatePhotoDialog.defaultProps = {
  isLoading: false,
  photoURL: '',
  icons: seedAppIcons,
};

export default SeedFirebaseUpdatePhotoDialog;
